export default __webpack_public_path__ + "static/media/knowMoreCustomer2.278ab994.png";